import { NgModule } from '@angular/core';
import { NavComponent } from './nav/nav.component';
import { CommonModule } from '@angular/common';
import { CompanyBoxComponent } from './company-box/company-box.component';
import { NavElementComponent } from './nav-element/nav-element.component';
import { UserBoxComponent } from './user-box/user-box.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { TabsComponent } from './tabs/tabs.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PillComponent } from './pill/pill.component';
import { StatusLightComponent } from './status-light/status-light.component';
import { UserTypeComponent } from './user-type/user-type.component';
import { PaginationComponent } from './pagination/pagination.component';
import { AlternativePaginationComponent } from './alternative-pagination/alternative-pagination.component';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from './modal/modal.component';
import { ImageCropperModalComponent } from './image-cropper-modal/image-cropper-modal.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReportModalComponent } from './report-modal/report-modal.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipDirective } from './tooltip/tooltip/tooltip/tooltip.component';
import { AlertComponent } from './alert/alert.component';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { InlineCheckboxComponent } from './inline-checkbox/inline-checkbox.component';



@NgModule({
  declarations: [
    NavComponent,
    CompanyBoxComponent,
    NavElementComponent,
    UserBoxComponent,
    PageHeaderComponent,
    TabsComponent,
    IconButtonComponent,
    PillComponent,
    StatusLightComponent,
    UserTypeComponent,
    AlertComponent,
    PaginationComponent,
    AlternativePaginationComponent,
    ModalComponent,
    ImageCropperModalComponent,
    ReportModalComponent,
    TooltipComponent,
    TooltipDirective,
    CustomDropdownComponent,
    InlineCheckboxComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ImageCropperModule,
    NgSelectModule
  ],
  exports: [
    NavComponent,
    CompanyBoxComponent,
    NavElementComponent,
    UserBoxComponent,
    PageHeaderComponent,
    TabsComponent,
    IconButtonComponent,
    StatusLightComponent,
    PillComponent,
    UserTypeComponent,
    AlertComponent,
    PaginationComponent,
    AlternativePaginationComponent,
    ModalComponent,
    ImageCropperModalComponent,
    ReportModalComponent,
    TooltipComponent,
    TooltipDirective,
    CustomDropdownComponent,
    InlineCheckboxComponent
  ]
})
export class CommonComponentsModule { }
